import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pagination--container" }
const _hoisted_2 = { class: "pagination--page__count ma--left-1" }
const _hoisted_3 = { class: "pagination--options" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-left" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.pageSize * (_ctx.page - 1) + 1) + " - " + _toDisplayString(_ctx.pageSize * (_ctx.page - 1) + _ctx.showPage) + " of " + _toDisplayString(_ctx.$filters.numberDisplay(_ctx.totalResults)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "btn btn--icon ma--left-1",
        disabled: _ctx.page == 1,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args)))
      }, _hoisted_6, 8, _hoisted_4),
      _createElementVNode("button", {
        class: "btn btn--icon ma--left-1",
        disabled: _ctx.totalPages == _ctx.page,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
      }, _hoisted_9, 8, _hoisted_7)
    ])
  ]))
}